export default __webpack_public_path__ + "static/hp-brand-deck-11-757e1c4775cd920e38599ffc535f0039.png";